import { grey } from "@mui/material/colors";

const styles = {
  section: {
    borderBottom: `1px solid ${grey[200]}`,
    px: { xs: 1, md: 3 },
    py: { xs: 0.5, md: 1.5 },
  },
};

export default styles;
